import { useTranslations } from "use-intl";
import { ContactContent } from "./contact-content";
import { Route } from "/app/apps/web/src/routes/_pages/$lang/_legal/contact/index.tsx";
function ContactPage() {
  const t = useTranslations("shared.contact");
  const {
    subject
  } = Route.useSearch();
  return <div className="not-prose">
      <h1 className="text-3xl font-bold mb-2">{t("title")}</h1>
      <p className="text-muted-foreground mb-8">{t("description")}</p>
      <ContactContent initialSubject={subject} />
    </div>;
}
export { ContactPage as component };